import React, { useState, useEffect } from "react";
import { Modal, Button, Table } from "antd";
import "../Reporting.scss";
import cancelX from "../../../../Assets/svg/cancelXbutton.svg";
import { httpService } from "../../../../services/httpService.service";

const Preview = ({ visible, onClose, siteVisitCardId }) => {
  const [siteLoader, setSiteLoader] = useState(false);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (visible && siteVisitCardId) {
      setSiteLoader(true);

      httpService.get(
        `/api/Site/getDataChecksBySiteVisit?siteVisitId=${siteVisitCardId}`,
        (res) => {
          setSiteLoader(false);
          setTableData((res.data || []).filter((row) => row?.target > 0));
        },
        (err) => {
          setSiteLoader(false);
        }
      );
    }
  }, [visible, siteVisitCardId]);

  const handleCancel = () => {
    setTableData([]);
    onClose();
  };

  const columns = [
    {
      title: "Tool",
      dataIndex: "tool",
      key: "tool",
    },
    {
      title: "Target #",
      dataIndex: "target",
      key: "target",
      align: "center",
    },
    {
      title: "Conducted (Actual)",
      dataIndex: "conducted",
      key: "conducted",
      align: "center",
    },
  ];

  return (
    <Modal
      title={
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <img
              src={cancelX}
              style={{ marginLeft: "auto", cursor: "pointer" }}
              onClick={handleCancel}
              alt="cancelX"
            />
          </div>
          <h2 className="modalHeader">Preview Data Checks</h2>
        </>
      }
      closable={false}
      open={visible}
      onClose={handleCancel}
      width={800}
      footer={
        <div className="buttonsModal">
          <Button
            className="inviteButtonTPM"
            key="cancel"
            onClick={handleCancel}
          >
            Close
          </Button>
        </div>
      }
    >
      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
        <Table
          columns={columns}
          dataSource={tableData}
          pagination={false}
          className="tpmTable1"
          loading={siteLoader}
        />
      </div>
    </Modal>
  );
};

export default Preview;
